import { cx } from '@linaria/core';
import { useRef, createElement } from 'react';
import { usePM2DisplayContext } from '@pm2/store';
import { withSlots, useToggleState } from '@utils/react';
import { CopyAction } from './action.copy/button.js';
import { PrintButton } from './action.print/button.js';
import { LegacyPrintButton } from './action.print-legacy/button.js';
import { UniversalContextMenu } from './molecule.contextmenu.js';
import { separator } from './organism.component-framework-contextmenu.style.js';
import { jsx } from 'react/jsx-runtime';
import { root } from './molecule.solid-button/button.style.js';
import { LegacyExportButton } from './action.export-legacy/button.js';
import { ExportButton } from './action.export/button.js';
import { LegacyDriveButton } from './action.drive-legacy/button.js';
import { DriveButton } from './action.drive/button.js';
import { ShareButton } from './action.share/button.js';
import { FloatingCloseButton } from './molecule.fab-button/menu.js';

const ComponentFrameworkContextMenu = withSlots(function ComponentFrameworkContextMenu(props) {
  const {
    inLibrary
  } = usePM2DisplayContext();
  const [active, actions] = useToggleState();
  const togglerRef = useRef(null);
  const buttons = props.slots.findAll("Button");
  const children = buttons.map((button, index) => {
    switch (button.type) {
      case "deactivate":
        if (props.layout !== "fab") {
          return null;
        }
        return /*#__PURE__*/jsx(FloatingCloseButton, {
          disabled: typeof props.enabled === "boolean" && !props.enabled || button.disabled,
          tooltip: button.tooltip,
          onClick: button.onDeactivate
        });
      case "share":
        return /*#__PURE__*/createElement(ShareButton, {
          ...button,
          key: "share",
          disabled: typeof props.enabled === "boolean" && !props.enabled || button.disabled
        });
      case "drive":
        return /*#__PURE__*/createElement(DriveButton, {
          ...button,
          key: "drive",
          disabled: typeof props.enabled === "boolean" && !props.enabled || button.disabled
        });
      case "drive-legacy":
        return /*#__PURE__*/createElement(LegacyDriveButton, {
          ...button,
          key: "drive",
          disabled: typeof props.enabled === "boolean" && !props.enabled || button.disabled
        });
      case "export":
        return /*#__PURE__*/createElement(ExportButton, {
          ...button,
          key: "export",
          disabled: typeof props.enabled === "boolean" && !props.enabled || button.disabled
        });
      case "export-legacy":
        return /*#__PURE__*/createElement(LegacyExportButton, {
          ...button,
          key: "export",
          disabled: typeof props.enabled === "boolean" && !props.enabled || button.disabled
        });
      case "print":
        return /*#__PURE__*/createElement(PrintButton, {
          ...button,
          key: "print",
          disabled: typeof props.enabled === "boolean" && !props.enabled || button.disabled
        });
      case "legacy-print":
        return /*#__PURE__*/createElement(LegacyPrintButton, {
          ...button,
          key: "print",
          disabled: typeof props.enabled === "boolean" && !props.enabled || button.disabled
        });
      case "extra":
        return button.children;
      case "separator":
        return /*#__PURE__*/jsx("li", {
          className: cx(props.layout === "solid" && root),
          children: /*#__PURE__*/jsx("hr", {
            className: separator
          })
        }, index);
    }
  });
  const menuProps = (() => {
    switch (props.layout) {
      case "fab":
        return {
          ...props,
          layout: "fab",
          children
        };
      case "solid":
        {
          const copyLink = (() => {
            if (!props.nodeId) {
              return null;
            }
            if (inLibrary) {
              // copying direct links from library is not supported; here link
              // copying is handled by the built-in functionality for that
              // purpose
              return null;
            }
            const url = new URL(window.location.href);
            url.hash = props.nodeId;
            return url.toString();
          })();
          return {
            ...props,
            togglerRef,
            layout: "solid",
            active,
            label: "Åbn kontekstmenuen",
            onToggle: actions.toggle,
            onClose: actions.disable,
            footer: copyLink ? /*#__PURE__*/jsx(CopyAction, {
              href: copyLink
            }) : undefined,
            children
          };
        }
    }
  })();
  return /*#__PURE__*/jsx(UniversalContextMenu, {
    ...menuProps
  });
});

export { ComponentFrameworkContextMenu };
//# sourceMappingURL=organism.component-framework-contextmenu.js.map
